import React, { useEffect } from "react";
import AOS from "aos";
import abImg1 from "../../images/about/about.webp";

const About = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);

  return (
    <section className="about-section section-padding" id="about">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-12">
            <div className="about-left-content">
              <div className="image">
                <img
                  src={abImg1}
                  alt="About CreaSnap"
                  loading="lazy"
                  data-aos="fade-up"
                />
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-12">
            <div className="about-right-content" data-aos="fade-up">
              <h2 className="title">TENTANG KAMI</h2>
              <h3 className="sub-title">Apa itu CreaSnap?</h3>
              <p className="text">
                CreaSnap merupakan agency yang bergerak di bidang jasa
                pengelolaan media sosial yang berfokus pada membantu bisnis,
                UMKM, dan individu dalam membangun serta mengoptimalkan
                kehadiran digital, khususnya melalui platform Instagram. Kami
                memahami bahwa media sosial bukan sekadar tempat berbagi konten,
                tetapi juga alat strategis untuk menjangkau audiens,
                meningkatkan interaksi, dan mendorong pertumbuhan bisnis.
                <span>
                  Dengan tim creasnap yang berpengalaman, kami akan mengelola
                  akun Instagram Anda secara profesional, Kami tidak hanya
                  membantu Anda membuat konten yang menarik, tetapi juga
                  merancang strategi yang efektif untuk menjangkau audiens
                  target Anda dan mendorong engagement.
                </span>
              </p>
              <div className="ceo-content">
                <h2>Reny Medikawati Taufiq, S.Kom., MT</h2>
                <span>CEO & Founder of CreaSnap</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="shape-1" data-aos="zoom-in">
        <svg width="429" height="593" viewBox="0 0 429 593" fill="none">
          <circle cx="296.5" cy="296.5" r="296.5" fill="url(#cc318_1506)" />
          <defs>
            <radialGradient
              id="cc318_1506"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(296.5 296.5) rotate(90) scale(296.5)"
            >
              <stop offset="0" stopColor="#CED0FF" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <div className="shape-2" data-aos="zoom-in">
        <svg width="529" height="529" viewBox="0 0 529 529" fill="none">
          <circle cx="264.5" cy="264.5" r="264.5" fill="url(#oo1508)" />
          <defs>
            <radialGradient
              id="oo1508"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(264.5 264.5) rotate(90) scale(264.5)"
            >
              <stop offset="0" stopColor="#FBB132" stopOpacity="0.2" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
};

export default About;
